import Weather from './services/weather'

document.addEventListener('DOMContentLoaded', () => {
    new Weather()
})
